import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DragDropModule } from "primeng/dragdrop";
import { SkeletonModule } from "primeng/skeleton";
import { IDocumentType } from "../../../../models/settings.model";
import { DocumentTypeFilter, DocumentTypeService } from "../../../../services/document-type.service";
import { DocumentTypesListComponent } from "../../document-types-list/document-types-list.component";

@Component({
    selector: 'app-document-types',
    imports: [
        CardModule,
        ButtonModule,
        CommonModule,
        ConfirmDialogModule,
        SkeletonModule,
        DragDropModule,
        DocumentTypesListComponent
    ],
    standalone: true,
    templateUrl: './document-types.component.html',
    styleUrl: './document-types.component.scss',
    providers: [ConfirmationService]
})
export class DocumentTypesComponent implements OnInit {

    docTypeLoading: boolean = false;
    docTypes: IDocumentType[] = [];

    constructor(
        private documentTypeService: DocumentTypeService
    ) {

    }

    ngOnInit() {
        this.getDocumentTypes();
    }

    getDocumentTypes() {
        this.docTypeLoading = true;
        this.documentTypeService.getDocTypes([DocumentTypeFilter.GENERAL, DocumentTypeFilter.FORM_RELATED]).subscribe(res => {
            if (res && res.success) {
                this.docTypeLoading = false;
                this.docTypes = res.data;
            } else {
                this.docTypeLoading = false;
            }
        });
    }

    onDocumentTypeSelected(docType: IDocumentType) {
        // this.selectedDocType = docType;
    }

}
